import {QUERY_KEYS} from '@/queryClient'
import {httpGetEventMembers} from '../services/events.http'
import {useQuery} from '@tanstack/react-query'

export const useGetEventMembers = ({eventId, workspaceId}: {eventId: string; workspaceId: string}) =>
    useQuery({
        queryKey: [QUERY_KEYS.WORKSPACE_EVENT_MEMBERS, workspaceId, eventId],
        queryFn: () => httpGetEventMembers(workspaceId, eventId)
    })
